export const authenticationErrorMap = {
  "auth/invalid-email": "The email address is badly formatted.",
  "auth/invalid-credential": "email or password is incorrect",
  "auth/user-disabled": "This user account has been disabled.",
  "auth/user-not-found":
    "There is no user record corresponding to this identifier.",
  "auth/wrong-password":
    "The password is invalid or the user does not have a password.",
  "auth/email-already-in-use": "Email already exists.",
  "auth/weak-password":
    "The password is too weak. Please choose a stronger password.",
  "auth/operation-not-allowed": "Sign-in with this provider is not enabled.",
  "auth/requires-recent-login":
    "This operation is sensitive and requires recent authentication. Please sign in again.",
  "auth/too-many-requests":
    "Too many attempts to sign in. Please try again later.",
  "auth/network-request-failed":
    "A network error has occurred. Please check your connection and try again.",
  "auth/popup-closed-by-user": "Google sign-in was cancelled before it completed.",
  "auth/cancelled-popup-request": "Another sign-in window was opened. Please try again.",
  "auth/popup-blocked": "Your browser blocked the Google sign-in popup. Please allow popups and try again.",
};
